import { Pipe, PipeTransform } from '@angular/core';

/**
 * Converts order.id into same web version of orderID E.g. '00000345'
 */
@Pipe({
  name: 'orderID',
  pure: false,
})
export class OrderIdPipe implements PipeTransform {
  transform(value: string): string {
    const arr = value.split('');
    switch (arr.length) {
      case 1:
        arr.unshift('0000000');
        break;
      case 2:
        arr.unshift('000000');
        break;
      case 3:
        arr.unshift('00000');
        break;
      case 4:
        arr.unshift('0000');
        break;
      case 5:
        arr.unshift('000');
        break;
      case 6:
        arr.unshift('00');
        break;
      case 7:
        arr.unshift('0');
        break;
      default:
        arr.unshift('');
    }
    return arr.join('');
  }
}
